<template>
  <v-card outlined class="rounded-lg">
    <v-card-title>Image map</v-card-title>
    <v-card-actions class="py-0">
      <v-row class="ma-0">
        <v-col>
          <v-file-input
            v-model="file"
            label="Upload map"
            accept="image/png, image/jpeg, image/bmp"
            placeholder="Select your map image"
            filled
            :prepend-icon="mdiMap"
            :loading="mapLoading"
            v-validate="{
              required: true,
            }"
            name="file"
            :error-messages="errors.collect('file')"
            :disabled="mapLoading"
          />
        </v-col>
        <v-col>
          <v-btn
            outlined
            :disabled="mapLoading"
            @click="uploadMap"
          >
            upload
          </v-btn>
        </v-col>
      </v-row>
    </v-card-actions>
  </v-card>
</template>

<script>
import { mdiMap } from "@mdi/js"
export default {
  data() {
    return {
      mdiMap,
      file: null,
      mapLoading: false,
    }
  },
  methods: {
    uploadMap() {
      this.$validator.validateAll().then(async res => {
        if (res) {
          this.mapLoading = true;
          let formData = new FormData();
          formData.set('file', this.file);
          let { data } = await this.$axios.post(this.$store.getters.projectPath + '/map/image', formData, {
            headers: {
              'content-type': 'multipart/form-data'
            }
          })
          this.mapLoading = false;
          this.$toasted.show(data);
        }
      })
    }
  }
}
</script>